import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/parcels.png'

const PropertyRecordsParcel = dynamic(() => import('src/components/insights/property-records/parcel'), { ssr: false })

export const PropertyRecordsParcelWidget: InsightBuilderWidget = {
  id: 'property-records-parcel',
  name: 'Property Records Parcel',
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  component: PropertyRecordsParcel,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
